export enum ItemPermission {
  View = 'viewer',
  Edit = 'editor',
  Contributor = 'contributor',
  Guest = 'guest'
}

export enum Action {
  Read = 'read',
  Write = 'write',
  Delete = 'delete',
  Share = 'share',
  Download = 'download'
}
